import { LOGS as ECP_LOGS, } from '@exodus/exchange-client-providers';
import { sanitizeErrorMessage } from '@exodus/errors';
import { ExchangeError } from '@exodus/exchange-client-providers';
import { safeString, isSafe } from '@exodus/safe-string';
import { LOGS as EXCHANGE_LOGS } from './constants.js';
const LOGS = Object.freeze({ ...ECP_LOGS, ...EXCHANGE_LOGS });
export class ExchangeTracerModule {
    #messages = [];
    #safeMessages = [];
    #timesById = new Map();
    #logger;
    timeLogs = new Map();
    constructor({ logger }) {
        this.#logger = logger;
    }
    traceMessage(message) {
        const logs = Object.values(LOGS);
        if (!logs.includes(message)) {
            this.#logger.warn(`Unknown message: ${message}`);
            return;
        }
        this.#messages.push(`[${new Date().toISOString()}]: ${sanitizeErrorMessage(message)}`);
        this.#safeMessages.push(message);
    }
    traceError(error) {
        const prettyPrintedError = this.#prettyPrintError(error);
        const message = error instanceof ExchangeError
            ? `${error.message} \n${prettyPrintedError}\nCLIENT_ERROR`
            : 'CLIENT_ERROR';
        this.#messages.push(sanitizeErrorMessage(message));
        this.#safeMessages.push(error instanceof ExchangeError ? error.name : safeString `CLIENT_ERROR`);
        this.#logger.error(message);
    }
    traceTime(id) {
        if (this.#timesById.has(id)) {
            this.#logger.warn(`Time tracer with id ${id} already started`);
            return;
        }
        const start = Date.now();
        this.#timesById.set(id, start);
    }
    traceTimeEnd(id) {
        const start = this.#timesById.get(id);
        if (!start) {
            this.#logger.warn(`Time tracer with id ${id} not started`);
            return;
        }
        const end = Date.now();
        const duration = end - start;
        this.timeLogs.set(id, duration);
        this.#timesById.delete(id);
    }
    clear() {
        this.#messages = [];
        this.#safeMessages = [];
        this.timeLogs.clear();
        this.#timesById.clear();
    }
    print() {
        return this.#messages.join('\n');
    }
    getSafeMessages() {
        return this.#safeMessages.filter((m) => isSafe(m));
    }
    #prettyPrintError(error) {
        return error instanceof ExchangeError
            ? Object.entries(error.toJSON())
                .map(([key, value]) => `${key}: ${typeof value === 'string' ? value : JSON.stringify(value)}`)
                .join('\n')
            : error.message;
    }
}
const exchangeTracerModuleFactory = (args) => new ExchangeTracerModule({ ...args });
const exchangeTracerModuleDefinition = {
    id: 'exchangeTracer',
    type: 'module',
    factory: exchangeTracerModuleFactory,
    dependencies: ['logger'],
};
export default exchangeTracerModuleDefinition;
